import { InviteChannel } from '@pflegia/types/common/match/invite-channel';

import { PayloadsType, VariantType } from '../utils/types';

export const Name = 'invite-channel';

export type PayloadType = InviteChannel;

export const Payloads: PayloadsType<PayloadType, VariantType> = {
  control: InviteChannel.Sms,
  test: InviteChannel.WhatsApp,
};
